import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem'
  },
  flexLeftCol: {
    flex: 0.4
  },
  flexRightCol: {
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word'
  }
}));

export default useStyles;
